import React, { useEffect } from "react";
import { TouchableOpacity, View, Modal, StyleSheet } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import { actions as miscActions } from "@reducers/miscReducer";
import CloseIcon from "@assets/svg/CloseIcon";

import analytics from "@services/analytics";

import OrderCancelled from "@assets/svg/OrderCancelled";
import OrderNotCancelled from "@assets/svg/OrderNotCancelled";

import Text from "@components/AppText";
import colors from "@constants/color";
import metrics from "@constants/metrics";
import {
  HIDE_ORDER_CANCEL_SUCCESS_MODAL,
  VIEW_ORDER_CANCEL_SUCCESS_MODAL,
} from "../constants/analyticsEvents";

import t from "../constants/localization";

const PATH = "components/OrderCancelSuccessModal";

const OrderCancelSuccessModal = (props) => {
  const dispatch = useDispatch();

  const { orderCancelSuccessModalVisible = false } = useSelector(
    ({ misc }) => misc,
  );

  const { allOrders = [], selectedOrder = "" } = useSelector(
    ({ orders }) => orders,
  );

  const {
    id: leader_id = "",
    name: leader_name = "",
    phone_neumber: leader_phone = "",
  } = useSelector(({ auth: { user } }) => user);

  const selectedOrderDetails =
    Array.isArray(allOrders) &&
    allOrders.length &&
    allOrders.find(({ order_id }) => +order_id === selectedOrder);

  const {
    order_id = "",
    total_amount: order_amount = "",
    items = [],
    collectible_amount: cod_amount = "",
    coupon_code = "",
    order_status = "",
    created_at: order_date = "",
  } = selectedOrderDetails || {};

  const {
    hasOrderCancelled = null,
    fromScreen = "",
    cancellationReason = "",
  } = props || {};

  useEffect(() => {
    analyticsEvent(VIEW_ORDER_CANCEL_SUCCESS_MODAL);
  }, []);

  const closeModalWithAnalytics = () => {
    dispatch(miscActions.hideOrderCancelSuccessModal());
    analyticsEvent(HIDE_ORDER_CANCEL_SUCCESS_MODAL);
  };

  const analyticsEvent = (eventName = "") => {
    // analytics.trackEvent(eventName, {
    //   order_id,
    //   cancellationReason,
    //   is_order_cancelled_after_7pm: !hasOrderCancelled,
    //   leader_id,
    //   leader_name,
    //   leader_phone,
    //   order_amount,
    //   num_of_items: items && items.length,
    //   items,
    //   discount: order_amount - cod_amount,
    //   coupon_code,
    //   cod_amount,
    //   order_status,
    //   order_date,
    //   screen: fromScreen,
    // });
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      animationType="fade"
      transparent
      visible={orderCancelSuccessModalVisible}
      onRequestClose={() => closeModalWithAnalytics()}
    >
      <View style={styles.container}>
        <View style={styles.wrapper}>
          <View
            style={[
              styles.beLikeRow,
              { justifyContent: "flex-end", alignItems: "center" },
            ]}
          >
            <TouchableOpacity onPress={() => closeModalWithAnalytics()}>
              <CloseIcon />
            </TouchableOpacity>
          </View>

          <View style={styles.graphicContainer}>
            {hasOrderCancelled !== null && hasOrderCancelled ? (
              <OrderCancelled />
            ) : (
              <OrderNotCancelled />
            )}
          </View>

          <View style={styles.textContainer}>
            <Text
              fontType="content1"
              style={{
                color: colors.mediumBlack,
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {hasOrderCancelled !== null && hasOrderCancelled
                ? t(`${PATH}/orderCancelled`)
                : t(`${PATH}/cantCancelOrder`)}
            </Text>
          </View>

          <TouchableOpacity
            style={styles.buttonsContainer}
            onPress={() => closeModalWithAnalytics()}
          >
            <Text
              fontType="head2"
              style={{
                color: colors.white,
                lineHeight: 28,
                fontWeight: "bold",
              }}
            >
              {t(`${PATH}/okay`)}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.modalBg,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 30,
  },
  beLikeRow: {
    flexDirection: "row",
  },
  wrapper: {
    backgroundColor: colors.white,
    elevation: 5,
    width: metrics.screenWidth * 0.9,
    padding: 20,
  },
  buttonsContainer: {
    width: "100%",
    height: 48,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    borderRadius: 10,
    backgroundColor: colors.primary,
  },
  radioBtnContainer: {
    paddingHorizontal: 5,
    marginVertical: 10,
    width: metrics.screenWidth,
  },
  graphicContainer: {
    padding: 10,
    alignSelf: "center",
  },
  textContainer: {
    paddingTop: 20,
    paddingBottom: 10,
    paddingHorizontal: 10,
    flexShrink: 1,
  },
});

export default OrderCancelSuccessModal;
